import React from "react";
import dynamic from "next/dynamic";
import InfoPageHero from "./individual-widgets/info-page-hero";

// Don't dynamic import hero components because it will increase element render delay for our LCP
const HIGH_PRIORITY_WIDGETS = {
  info_page_hero: {
    Component: InfoPageHero,
  },
};

// These widgets will appear below the fold so can be dynamic imported
const LOW_PRIORITY_WIDGETS = {
  featured_projects: {
    Component: dynamic(() => import("./individual-widgets/featured-projects")),
  },
  faqs: {
    Component: dynamic(() => import("./individual-widgets/faqs")),
  },
  features_showcase: {
    Component: dynamic(() => import("./individual-widgets/features-showcase")),
  },
  text: {
    Component: dynamic(() => import("./individual-widgets/text")),
  },
  text_v2: {
    Component: dynamic(() => import("./individual-widgets/text-v2")),
  },
  subheading: {
    Component: dynamic(() => import("./individual-widgets/subheading")),
  },
  full_width_image: {
    Component: dynamic(() => import("./individual-widgets/full-width-image")),
  },
  map: {
    Component: dynamic(() => import("./individual-widgets/map")),
  },
  text_in_a_coloured_panel: {
    Component: dynamic(
      () => import("./individual-widgets/text-in-coloured-panel")
    ),
  },
  gallery: {
    Component: dynamic(() => import("./individual-widgets/gallery")),
  },
  sustainable_development_goals: {
    Component: dynamic(
      () => import("./individual-widgets/sustainability-development-goals")
    ),
  },
  rows_of_alternating_copy_and_image: {
    Component: dynamic(
      () => import("./individual-widgets/row-alternating-copy-and-images")
    ),
  },
  lead_gen_form: {
    Component: dynamic(
      () => import("./individual-widgets/lead-generation-form"),
      { ssr: false }
    ),
  },
  data_table: {
    Component: dynamic(() => import("./individual-widgets/data-table")),
  },
  mascot_cta: {
    Component: dynamic(() => import("./individual-widgets/mascot-cta")),
  },
};

/**
 * Uses data from the Wordpress API to determine which widgets (i.e. React components) to
 * render
 */
export const WidgetBuilder = ({ data, ...extraData }: any) => (
  <>
    {data.acf.widgets.map((widget: any, idx: number) => {
      const key = `${idx}-${data.id}`;
      const props = { key, data: widget, ...extraData };
      const allWidgets = { ...HIGH_PRIORITY_WIDGETS, ...LOW_PRIORITY_WIDGETS };
      const widgetComponent = allWidgets[widget.acf_fc_layout];

      if (widgetComponent) {
        const { Component } = widgetComponent;
        return <Component {...props} />;
      } else {
        console.error(
          `WidgetBuilder: No widget found for ${widget.acf_fc_layout} when building "${data.slug}"`
        );
      }

      return null;
    })}
  </>
);
